export function addStyleLink(url: string) {
  if (document.querySelector('link[href="' + url + '"]')) {
    return;
  }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  document.head.prepend(link);
}
